import { useTranslation } from 'react-i18next';
import { eAgendaTabs } from '../Calendar.enums';
import { useCalendarContext } from '../Calendar.hook';

export default function SubHeader() {
  const { currentTab } = useCalendarContext();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div
        className={`${
          currentTab === eAgendaTabs.EVENTS
            ? 'justify-center'
            : 'justify-between'
        } flex flex-row px-4 pb-6`}
      >
        <div />
      </div>
      {currentTab === eAgendaTabs.EVENTS && (
        <>
          <div className="flex justify-center mb-6">
            <h1 className="text-xl text-primary font-bold">Lista de Eventos</h1>
          </div>
          <div className="grid grid-cols-12 py-4 bg-primary/40 rounded text-primary text mx-2">
            <div className="col-auto">
              <p className=""></p>
            </div>
            <div className="col-span-2">
              <p className=" ">{t('agenda/agenda:event-name')}</p>
            </div>
            <div className="col-span-2 pl-3">
              <p className="">{t('agenda/agenda:event-type')}</p>
            </div>
            <div className="col-span-2">
              <p className="">{t('agenda/agenda:assigned-lead')}</p>
            </div>
            <div className="col-span-2 text-center">
              <p className="">{t('agenda/agenda:send-notification')}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
